/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/system';

import Color from '@tool/color';
import '../scss/common.scss';
import moQuestion, {
  changeQuestion,
  changeEleven,
  changeElevenEdit,
} from '../store';
import {
  ActiveLinearProgress,
  BorderLinearProgress,
  DInput,
  DefaultLinearProgress,
  NextButton,
  PrevButton,
  DCheckbox,
} from '@/styled/button';
import { cloneDeep, isEmpty, round } from 'lodash';
import { submitQuestion } from '@/styled/common';
import { observer } from 'mobx-react';

const ElevenQuestion = (props: any) => {
  const { elevenAnswer, elevenEdit, curtime } = moQuestion;
  const [twoList, setTwoList] = useState<any>([]);
  const [type, setType] = useState('question');
  const oneList = [
    '无',
    '年终奖',
    '绩效奖金',
    '盈利分红',
    '长期服务奖金',
    '其他',
  ];

  const onSave = async () => {
    const arr = elevenAnswer?.map((res: any) => {
      let items = cloneDeep(res);
      if (res === '其他') {
        items = `${res}-${elevenEdit}`;
      }
      return items;
    });
    const result = await submitQuestion('公司提供哪些浮动薪酬', arr, curtime);
    const arr1: any = [];
    oneList.forEach((res: any) => {
      if (result.some((ele: any) => ele.answer === res)) {
        result.forEach((ele: any) => {
          if (res === ele.answer) {
            arr1.push(round(ele.ratio * 100, 1));
          }
        });
      } else {
        arr1.push(0);
      }
    });
    setTwoList(arr1);
    setType('answer');
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="allQuestion">
      {type === 'question' ? (
        <section className="allContent">
          <h2>
            四、短期激励<span>（考核周期≦1年）</span>
          </h2>
          <h3>
            4.1 公司提供哪些浮动薪酬？<span>（多选）</span>
          </h3>
          {oneList?.map((res: any) => {
            return (
              <div
                className="checkList"
                key={res}
                onClick={() => {
                  changeEleven(res);
                }}>
                <DCheckbox
                  style={{
                    color: elevenAnswer.includes(res) ?
                      Color.primary :
                      Color.c87,
                  }}
                  size="small"
                  checked={elevenAnswer.includes(res)}/>
                <span className={elevenAnswer.includes(res) ? 'active' : ''}>
                  {res}
                </span>
                {res === '其他' && (
                  <DInput
                    value={elevenEdit}
                    onClick={(e: any) => {
                      e.stopPropagation();
                    }}
                    onChange={(e: any) => {
                      changeElevenEdit(e.target.value);
                    }}/>
                )}
              </div>
            );
          })}
        </section>
      ) : (
        <section className="allContent">
          <h2>四、短期激励</h2>
          <h3>4.1 短期浮动薪酬统计结果</h3>
          {oneList?.map((res: any, r: any) => {
            return (
              <section key={res} className="items">
                <section
                  className={
                    elevenAnswer.includes(res) ? 'proActive' : 'process'
                  }>
                  <b>{res}</b>
                  <label>{`${twoList[r]}%`}</label>
                </section>
                {!elevenAnswer.includes(res) ? (
                  <DefaultLinearProgress
                    variant="determinate"
                    value={twoList[r]}/>
                ) : (
                  <ActiveLinearProgress
                    variant="determinate"
                    value={twoList[r]}/>
                )}
              </section>
            );
          })}
        </section>
      )}
      <section className="btnGroup">
        <section className="numProgress">
          <p className="num">
            <span>11</span> / 15
          </p>
          <BorderLinearProgress variant="determinate" value={(11 / 15) * 100} />
        </section>
        <PrevButton
          onClick={() => {
            changeQuestion(10);
          }}>
          上一题
        </PrevButton>
        {type === 'question' ? (
          <PrevButton
            onClick={() => {
              changeQuestion(12);
            }}>
            跳过此题
          </PrevButton>
        ) : (
          <PrevButton
            onClick={() => {
              setType('question');
            }}>
            重新填写
          </PrevButton>
        )}
        {type === 'question' ? (
          <NextButton onClick={onSave} disabled={isEmpty(elevenAnswer)}>
            保存查看结果
          </NextButton>
        ) : (
          <NextButton
            onClick={() => {
              changeQuestion(12);
            }}>
            下一题
          </NextButton>
        )}
      </section>
    </section>
  );
};

export default observer(ElevenQuestion);
